import React from 'react';
import { Box, Stack } from '@mui/material';
import {
  AppButton,
  AppButtonTone
} from '@client/foundation/design-system/components';

export type GridActionToolbarAction = {
  key: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  tone?: AppButtonTone;
};

export type GridActionToolbarProps = {
  actions: GridActionToolbarAction[];
};

export const GridActionToolbar: React.FC<GridActionToolbarProps> = ({
  actions
}) => {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'flex-end',
        backgroundColor: (theme) =>
          theme.designSystem.surface.gridFooterBackground,
        borderTop: (theme) =>
          `1px solid ${theme.designSystem.surface.toolbarDivider}`
      }}
    >
      <Stack direction="row" spacing={2}>
        {actions.map((action) => (
          <AppButton
            key={action.key}
            tone={action.tone ?? 'primary'}
            disabled={action.disabled}
            onClick={action.onClick}
            sx={{ minWidth: 96 }}
          >
            {action.label}
          </AppButton>
        ))}
      </Stack>
    </Box>
  );
};
